import React from 'react';

const About = () => (
  <section className="py-20 px-4 bg-white text-center">
    <h2 className="text-3xl font-bold mb-4">About Us</h2>
    <p className="text-lg max-w-2xl mx-auto">
      We provide innovative and sustainable water treatment solutions for industries, ensuring clean and safe water for all applications.
    </p>
  </section>
);

export default About;
